import TimeTrackingReasonsRequests from '../../server/timeTrackingReasons';
import { addLoading, removeLoading } from './loading';

export const setTimeTrackingReasons = (timeTrackingReasons) => ({
  type: 'SET_TIME_TRACKING_REASONS_LIST',
  timeTrackingReasons,
});

export const createTimeTrackingReason = (timeTrackingReason) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const newTimeTrackingReason = await TimeTrackingReasonsRequests.createTimeTrackingReason(timeTrackingReason);
    return newTimeTrackingReason;
  } finally {
    dispatch(removeLoading());
  }
};

export const updateTimeTrackingReason = (timeTrackingReason) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TimeTrackingReasonsRequests.updateTimeTrackingReason(timeTrackingReason);
  } finally {
    dispatch(removeLoading());
  }
};

export const getTimeTrackingReason = (timeTrackingReasonId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TimeTrackingReasonsRequests.getTimeTrackingReason(timeTrackingReasonId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getTimeTrackingReasonsList = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    const timeTrackingReasons = await TimeTrackingReasonsRequests.getTimeTrackingReasons();
    dispatch(setTimeTrackingReasons(timeTrackingReasons));
  } finally {
    dispatch(removeLoading());
  }
};

export const getTimeTrackingReasonsOptions = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TimeTrackingReasonsRequests.getTimeTrackingReasonsOptions();
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteTimeTrackingReason = (timeTrackingReasonId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TimeTrackingReasonsRequests.deleteTimeTrackingReason(timeTrackingReasonId);
  } finally {
    dispatch(removeLoading());
  }
};
